/**
 * Coarse mainland-China coverage used to decide whether GCJ-02 conversion
 * applies. The previous bounding box also included large parts of Vietnam,
 * Mongolia and other neighbouring countries.
 *
 * Boundary coordinates are simplified from Natural Earth 1:110m Admin 0
 * Countries (public domain):
 * https://www.naturalearthdata.com/downloads/110m-cultural-vectors/
 */
const GCJ02_COVERAGE_POLYGONS = [
  [
    [80.25999, 42.349999],
    [79.966106, 44.917517],
    [83.180484, 47.330031],
    [85.768233, 48.455751],
    [87.35997, 49.214981],
    [88.013832, 48.599463],
    [90.280826, 47.693549],
    [90.585768, 45.719716],
    [93.480734, 44.975472],
    [95.306875, 44.241331],
    [96.349396, 42.725635],
    [99.515817, 42.524691],
    [101.83304, 42.514873],
    [104.522282, 41.908347],
    [106.129316, 42.134328],
    [109.243596, 42.519446],
    [111.129682, 43.406834],
    [111.348377, 44.457442],
    [112.436062, 45.011646],
    [114.460332, 45.339817],
    [117.421701, 46.672733],
    [119.772824, 47.048059],
    [117.295507, 47.697709],
    [115.485282, 48.135383],
    [116.678801, 49.888531],
    [119.288461, 50.142883],
    [120.18208, 51.64355],
    [120.725789, 52.516226],
    [122.245748, 53.431726],
    [125.068211, 53.161045],
    [126.939157, 51.353894],
    [127.6574, 49.76027],
    [130.582293, 48.729687],
    [132.50669, 47.78896],
    [135.026311, 48.47823],
    [133.769644, 46.116927],
    [133.09712, 45.14409],
    [131.02519, 44.96796],
    [131.144688, 42.92999],
    [130.64, 42.395024],
    [129.596669, 42.424982],
    [128.052215, 41.994285],
    [126.869083, 41.816569],
    [125.079942, 40.569824],
    [122.86757, 39.637788],
    [121.054554, 38.897471],
    [122.168595, 40.422443],
    [120.768629, 40.593388],
    [119.023464, 39.252333],
    [117.532702, 38.737636],
    [118.87815, 37.897325],
    [120.823457, 37.870428],
    [122.357937, 37.454484],
    [121.104164, 36.651329],
    [119.664562, 35.609791],
    [120.620369, 33.376723],
    [121.908146, 31.692174],
    [121.264257, 30.676267],
    [122.092114, 29.83252],
    [121.684439, 28.225513],
    [120.395473, 27.053207],
    [119.585497, 25.740781],
    [117.281606, 23.624501],
    [115.890735, 22.782873],
    [114.763827, 22.668074],
    [114.152547, 22.22376],
    [113.80678, 22.54834],
    [113.241078, 22.051367],
    [111.843592, 21.550494],
    [110.785466, 21.397144],
    [110.444039, 20.341033],
    [109.627655, 21.008227],
    [108.522813, 21.715212],
    [107.04342, 21.811899],
    [106.567273, 22.218205],
    [106.725403, 22.794268],
    [105.811247, 22.976892],
    [105.329209, 23.352063],
    [104.476858, 22.81915],
    [102.706992, 22.708795],
    [101.652018, 22.318199],
    [101.80312, 21.174367],
    [100.416538, 21.558839],
    [99.240899, 22.118314],
    [98.660262, 24.063286],
    [98.671838, 25.918703],
    [98.68269, 27.508812],
    [97.327114, 28.261583],
    [96.248833, 28.411031],
    [96.117679, 29.452802],
    [94.56599, 29.277438],
    [92.503119, 27.896876],
    [91.258854, 28.040614],
    [89.47581, 28.042759],
    [88.814248, 27.299316],
    [88.120441, 27.876542],
    [85.82332, 28.203576],
    [83.898993, 29.320226],
    [82.327513, 30.115268],
    [81.111256, 30.183481],
    [79.721367, 30.882715],
    [78.458446, 32.618164],
    [78.912269, 34.321936],
    [77.837451, 35.49401],
    [75.896897, 36.666806],
    [74.980002, 37.41999],
    [74.257514, 38.606507],
    [73.675379, 39.431237],
    [74.776862, 40.366425],
    [76.526368, 40.427946],
    [78.187197, 41.185316],
    [80.11943, 42.123941],
  ],
  [
    [109.47521, 18.197701],
    [108.655208, 18.507682],
    [108.626217, 19.367888],
    [109.119056, 19.821039],
    [110.211599, 20.101254],
    [110.786551, 20.077534],
    [111.010051, 19.69593],
    [110.570647, 19.255879],
    [110.339188, 18.678395],
  ],
]

export function isInGcj02Coverage (longitude, latitude) {
  const lng = Number(longitude)
  const lat = Number(latitude)
  if (!Number.isFinite(lng) || !Number.isFinite(lat)) {
    return false
  }
  return GCJ02_COVERAGE_POLYGONS.some(polygon => pointInPolygon(lng, lat, polygon))
}

function pointInPolygon (longitude, latitude, polygon) {
  let inside = false
  for (let current = 0, previous = polygon.length - 1; current < polygon.length; previous = current++) {
    const [currentLongitude, currentLatitude] = polygon[current]
    const [previousLongitude, previousLatitude] = polygon[previous]
    const crosses = (currentLatitude > latitude) !== (previousLatitude > latitude) &&
      longitude < (previousLongitude - currentLongitude) *
      (latitude - currentLatitude) / (previousLatitude - currentLatitude) +
      currentLongitude
    if (crosses) {
      inside = !inside
    }
  }
  return inside
}
